import { configureStore } from "@reduxjs/toolkit";

import api from "@/store/api";
import rootReducer from "@/store/reducers";
import { shouldUseDevToolsEnhancer } from "@/utils/environment.util";

type RootState = ReturnType<typeof rootReducer>;

const setupStore = (preloadedState?: Partial<RootState>) => {
  // Conditionally load devtools enhancer only in development to reduce startup overhead
  const devToolsEnhancer = shouldUseDevToolsEnhancer()
    ? // eslint-disable-next-line @typescript-eslint/no-require-imports
      require("redux-devtools-expo-dev-plugin").default
    : undefined;

  return configureStore({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    devTools: false,
    enhancers: (getDefaultEnhancers) =>
      devToolsEnhancer
        ? getDefaultEnhancers().concat(devToolsEnhancer())
        : getDefaultEnhancers(),

    middleware: (getDefaultMiddleware) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions -- legitimate use case
      getDefaultMiddleware().concat(api.middleware) as any,
    preloadedState,
    reducer: rootReducer,
  });
};

const store = setupStore();

type AppStore = ReturnType<typeof setupStore>;
type AppDispatch = AppStore["dispatch"];

export type { AppDispatch, AppStore, RootState };

export { setupStore };
export default store;
